var AddTrim = (function() {
	var __private = {
		button    : document.getElementById("vinNext"),
		trimManual: document.getElementById("trim"),
		trimField : document.querySelector("input[name='trim_from_vin']"),

		listener() {
			// first trim field
			if(this.trimManual instanceof HTMLInputElement) {
				this.trimManual.addEventListener("change", function() {
					if(__private.trimField instanceof HTMLInputElement) __private.trimField.value = this.value;
				});
			}
		},

		IEfix() {
			if(this.trimField instanceof HTMLInputElement && this.trimField.form === null) {
				// input change
				this.trimField.addEventListener("change", function() {
					fixTrimIE.call(this);
				});

				// button click
				document.addEventListener("click", function(event) {
					event = event || window.event;
					var target = event.target;

					if(target instanceof HTMLElement && target.getAttribute("role") === "menuitem")
						fixTrimIE.call(__private.trimField);
				})
			}

			function fixTrimIE(params) {
				var cloneID = "trimIEClon";
				var cloneNode;

				if(document.getElementById(cloneID)) cloneNode = document.getElementById(cloneID);
				else cloneNode = cloned(cloneID, this.name);

				cloneNode.value = this.value;
			}

			function cloned(ID, name) {
				var form  = document.getElementById("steps-uid-0")
				var input = document.createElement("input");

				input.id = ID;
				input.name = name;
				input.type = "hidden";

				form.appendChild(input);

				return input;
			}
		}
	};

	return {
		init() {
			__private.listener();
			__private.IEfix();
		}
	};
})();

(function() {
	document.addEventListener("DOMContentLoaded", function() {
		AddTrim.init();

		// hidden trim field
		let trimField = document.getElementById("isTrimField");
		let trimWrapp = document.getElementById("trimIsTrue");

		if(trimField instanceof HTMLElement && trimWrapp === null) trimField.style.display = "none"; 
	});
})();